import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { saveExpenseDraftUseCase } from '@webapp/modules/expense/business-logic/use-cases/SaveExpenseDraft'
import { type ExpenseReportFormSchema } from '@webapp/modules/expense/components/CreateExpenseReportForm'
import { expenseQueryConfig } from '@webapp/modules/expense/query-configs/expense'

export const useMutateSaveExpenseDraft = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    { id: number },
    RepoError,
    ExpenseReportFormSchema
  >({
    mutationFn: (formValues) => saveExpenseDraftUseCase.execute(formValues),

    onSuccess: () => {
      queryClient.invalidateQueries(expenseQueryConfig.drafts().queryKey)
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
